import { render, staticRenderFns } from "./SpecificForm.vue?vue&type=template&id=ed123344&scoped=true"
import script from "./SpecificForm.vue?vue&type=script&lang=js"
export * from "./SpecificForm.vue?vue&type=script&lang=js"
import style0 from "./SpecificForm.vue?vue&type=style&index=0&id=ed123344&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed123344",
  null
  
)

export default component.exports